module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER TWO")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tuesday, June 3, 1902—12:45 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RANCESCA WAS DISBELIEVING.")])]), _vm._v(" Hart was the very last person she had expected to see. What was he doing in the city?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then she saw the dark stain on Hart’s white shirt, where his suit jacket was unbuttoned. “Calder?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hurried toward her, his own surprise fading. “Francesca!” he exclaimed, and his expression changed, becoming displeased. “Why am I not surprised to find you here?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you hurt?” she demanded, but the beginnings of a terrible fear had crept into her mind. Somehow, she knew the blood was Daisy’s. She stiffened, staring up at his dark, handsome face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not hurt.” He took her arm, as if to steady her. “Daisy is dead, Francesca.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She met his probing regard, her mind scrambling to sort through the confusion. “I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The blood is hers, Francesca, not mine. I found her in the study. She had been stabbed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their eyes met. All of Francesca’s shock suddenly vanished. He was supposed to be in Boston. When had he returned to town and why hadn’t he called her? What was he doing here at Daisy’s, in the kitchen and servants’ quarters? Given the blood on the front of his shirt, he had held Daisy, too, the way Rose had. Some thing sharp and distasteful filled her: dread. “Calder, Rose said she found Daisy. In fact, she sent me a note asking me to come here.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When I arrived, Rose wasn’t here.” His regard held hers. “I found Daisy on the floor of the study, very much alone.” He looked away from her now. His composure was usually rock solid, but Francesca saw that he was struggling to maintain it. “She was already dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca swallowed, feeling ill. “You checked for a pulse?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He met her gaze. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca felt as if she were interrogating a suspect. Of course, that was not the case. “When did you arrive here, Calder?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His look was sharp. “I left my home around eleven,” he said. Then, softly, with warning, he added, “I do not want you involved, Francesca.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca’s tension rose. She was already involved, because Daisy had once been Hart’s mistress, because she had once been Francesca’s friend and because she had recently been her rival.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Francesca,” he said, his tone pointed, and he took her wrist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked into his eyes. “Daisy is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dead,")]), _vm._v(" Hart. She has been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("murdered.")]), _vm._v(" I think we are both involved.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He turned away, but not before Francesca saw the anguish in his eyes. She was shocked. Had she imagined it, or did Calder have some feelings for Daisy still, after all of this time?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He slowly faced her. “You are staring.” His tone had softened and his hand slipped to her palm. “Francesca, I am also in shock. We had better summon the police.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart raced with painful force. If she had seen anguish in his eyes, it was now gone. He seemed grim, but not grief-stricken. Of course he would be distraught that a woman he had once known intimately was dead. “Calder, what are you doing here?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("He hesitated, his expression hardening. “I finished my affairs in Boston earlier than expected. I arrived at Grand Central at a quarter to seven this evening.” He met her gaze directly. “After I found Daisy, I decided to look for the killer. I was about to do ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("so when Rose came into the house. She was not wearing any wrap—clearly she had just stepped out. I hid. She went directly to the study, Francesca, directly to Daisy. I followed her. She was not surprised to see Daisy murdered.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca’s mind raced. Calder had not answered her question. He had not told her why he was at Daisy’s in the first place. Any affairs that remained between him and Daisy were of a financial nature. Such concerns could have waited. It was well after midnight now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If he had left his uptown home at eleven, he would have arrived at Daisy’s perhaps an hour ago. What had he been doing in the house for all of that time? Her pulse quickened with fear. She did not have to be thinking all that clearly now to know that Hart could be in trouble with the law. “And then what happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I left her and went to search the house.” He released his hand from hers and tilted up her chin. “You’re upset. I am, as well. We’ll get through this, Francesca.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca tried to smile at him and was fairly certain she had failed. “Of course we will. But Daisy is dead, Calder. As malicious as she was toward me, toward us—she did not deserve to die, and certainly not so violently.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face tightened and something dark and deep flared in his eyes. “No. As much trouble as she caused us recently, she did not deserve to die.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly Francesca recalled that day last month out side of the church. After taunting her, Daisy had walked away. Hart had come outside, the memorial service over. He had been grim and resolute, and he had told her in no uncertain words not to worry.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I will take care of Daisy.")]), _vm._v(" Those had been his exact words. Now Francesca felt a surge of fear and she tried to think if anyone might have overheard his statement. Of course, Calder hadn’t meant he would murder Daisy; he had meant he would make sure that she no longer bothered either one of them. But Daisy ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("had been his mistress until a few months ago, and he continued to support her financially. Francesca had investigated enough crimes of passion to know that Hart should be kept out of this case. “Calder, you should leave right now. I will find a roundsman and alert Bragg. Did any one else see you? Did Rose see you?”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave her an odd look. Softly, he said, “Are you trying to protect me, Francesca?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stiffened, but that single look caused her heart to skip. “Very well, I confess. Yes, I want to protect you. You should stay as far away from this house and the murder scene as possible.” It crossed her still-dazed mind that she would have to lie to the police, if no one was to know that Calder had been at Daisy’s that night. She didn’t know how she would manage telling such a lie to Rick Bragg.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart’s eyes smoldered. “I already spoke to Homer, the butler, and the housemaid. They are in their quarters, where I told them to remain. They both know I am here. I don’t think Rose saw me. I found Daisy murdered, Francesca—I didn’t murder her myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was angry and she knew it. Quickly she took his hand but he shook her off. “Hart! I know you didn’t kill her!” Of that, she had no doubt. “But you were here on the night of her death. You could be implicated.” Francesca hoped that the coroner would discover that Daisy had been killed before a quarter to seven that evening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t need to protect me, Francesca,” he said. “Besides, half the city knows I have been keeping her. I cannot deny our relationship. But remember, Rose was here before me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That is your word against hers.” Francesca rubbed her temples, which throbbed. No good was going to come of this. A crystal ball could not have been clearer! If she did not find another suspect, and quickly, the police were going to consider Hart a prime suspect. She looked up and found him regarding her steadily, his gaze far too intent.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Suddenly he softened. He reached out and touched her cheek. “Why are we arguing? You don’t need to protect me, Francesca, as I have done nothing wrong. And I have been fending for myself since I was a small boy, stealing scraps of food on the streets. And I have missed you,” he added even more softly, and his tone was impossible to resist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have missed you, too,” she whispered shakily, moving into his arms as he reached out to her. She stood there, still grieving yet overcome with relief, pressed against his hard, powerful body. This was where she most wanted to be. Something terrible would come of this case, she just knew it. She was afraid for him, for her, for them both. But as afraid as she was, she had never loved him more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart held her silently for a long moment, and she felt his strong heart begin to increase its beat. Her own pulse could not help but skip and dance when she was in his arms. Francesca lifted her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He touched her lips with his, once, twice, three times.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beneath the gentle brushing, Francesca sensed his urgency and need. In response, as always, a fire roared to life in her veins. Their eyes met and held. Then Hart stepped back. “We should respect the dead,” he said seriously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, we should.” Francesca folded her arms across her chest and gave herself a moment to refocus. “Rose is with…the body.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rose,” he repeated. “Could she have murdered the woman she loved? Might she have already been here when I arrived? When did she send you this note, Francesca?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Francesca could not imagine Rose killing her best friend, but she would consider it, of course. “The note arrived at my home before midnight. Let’s estimate that it arrived by a quarter to the hour. Rose wrote and sent the note around eleven or shortly thereafter. She was undoubtedly sending me the note, which came by cab, when you walked in.” It crossed her mind that most ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("of the suspicion could be directed at Rose. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She")]), _vm._v(" found the body before you did. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She")]), _vm._v(" was first on the scene.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stared for a moment. “I have never trusted Rose. Why did she send for you, of all people? There was no love lost between any of us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca hesitated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me guess,” he said sarcastically. “She wants you to find the killer?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca bit her lip. “Calder,” she began, deter mined to head him off at the pass. Even though he was always supportive of her investigations and proud of her success in them, she knew why he did not want her on this particular case—and the reason was Daisy. “This is a crime of passion. I do not think it will be hard to find the killer. From what I saw,” she added, an image of Daisy’s mutilated chest coming to mind, “someone stabbed Daisy repeatedly in a fit of anger.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You cannot predict the nature of this investigation!” Hart exclaimed. “Do not mistake me now, Francesca, this is one case where I do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" want you involved.” His look was uncompromising.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" involved. She was your ex-mistress and I am your fiancée.” Francesca tried to be firm and gentle at once.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He made an angry sound and took her arm. “I am asking you, this one single time, to leave the investigation of Daisy’s murder alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That terrible feeling of dread rose swiftly up again. Francesca stole a look at Hart’s angry expression, her heart sinking. Now was clearly not the time to tell him that nothing and no one—not even Hart—could stop her from finding Daisy’s killer. But why did he want her off the case so badly? Surely he had nothing to hide, not from her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is too personal for us both,” Hart said in a calmer tone, as if that explained his reasoning, but it explained nothing at all.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, it is personal for us both,” Francesca said noncommittally. She was aware of the exasperated look he cast at her, but now she was wondering about Rose. She had yet to ask her exactly when she had found Daisy. Given the extent of her grief, it was possible she had sat with her dead friend for quite some time before writing Francesca the note. One fact was clear—Daisy had been murdered before eleven or half past eleven p.m., when Rose had sent Francesca the note.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Together, they moved toward the study, where the candle continued to flicker. As they approached, Francesca’s steps slowed, as did Hart’s. His grasp on her hand tightened, but with reassurance, not warning. Francesca glanced at him and he tried to smile at her, but the curve of his firm mouth could not extinguish the sadness in his dark navy blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was far more upset than he was letting on, she thought with dismay. God, what if he still had feelings for Daisy? Could she possibly manage that, when Daisy had always felt like a threat to her relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rose was now sitting on the sofa, curled up like a child, her knees to her chest, the dark green evening gown she wore stained with blood. Daisy remained on the floor, covered from head to toe with the throw. Hearing their footsteps, Rose looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She shot to her feet, pointing, her hand shaking. “You! I should have known! You goddamned bastard! You killed her!”")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Police Commissioner Accused of Dereliction of Duty")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Commissioner Bragg Fails Reformers")]), _vm._v(" "), _c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_vm._v("Civic Leaders Outraged with Police Policy")])])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("N DISGUST")]), _vm._v(", R"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ICK")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RAGG")]), _vm._v(" swept all three newspapers from his desk, cradling his head in his hands. His head ached and he was impossibly tired. He had never felt more worn, and that had nothing to do with the fact that the grandfather clock in the hall had just chimed a single time, indicating it was one in the ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("morning. Right now, he almost regretted accepting the mayor’s appointment, an appointment that had initially been filled with excitement and hope. He was the first police commissioner since Teddy Roosevelt to attempt the monumental mission of reforming the city’s notoriously corrupt police force. But the hottest issue of the day was his undoing, especially as the mayor had tied his hands behind his back, refusing to allow him to do his job as he wished to do it.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg sighed and reached for his bourbon. Mayor Low was already afraid of the vast German vote and had decided to ask the police not to enforce the blue laws, which required the closing of saloons on the Sabbath. Yet every reform group in the city was in favor of such closings. But after a series of crackdowns, Tammany Hall had made it a point to stir up as much trouble for Bragg and his force as possible. The German workers of the city were in an up roar, demanding their rights in protests and petitions. Afraid of losing reelection, Low had told Bragg to back off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Low was good for the city. He was a man dedicated to social and political reform and he was courageous enough to oppose Tammany Hall. He was also Bragg’s boss. There was no way Rick could refuse his orders, even if it meant compromising his own oath to uphold and obey the law.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could please no one now. The reformers, led by the clergy and the city’s progressive-minded elites, wanted his head and his resignation. So did half of his own force, due to the internal shake up he had inflicted these past five months, reassigning officers left and right to break up the rings of graft and bribery that manacled the city in a web of corruption and lies. Low had made it clear that he wished for Rick to continue on; given the circumstances, he was pleased with the internal cleanup of the force. Rick hadn’t really been considering resignation, but sometimes, on an endless day like this one, it crossed his mind.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was never at home, and his family had never needed him more.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He drank, finishing the bourbon and pouring another one. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("His family.")]), _vm._v(" Images of his beautiful wife and the two little girls they had decided to adopt filled his mind. Who was he fooling? He had finished all the urgent paperwork an hour or two ago and had chosen to linger over the damn dailies, with their accusatory headlines, because he was afraid to go upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was afraid to go to the bedroom he shared with his wife, afraid to go to their bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He leaned his face on his hands, closing his eyes, so tired he thought he could fall asleep at his desk. And it wasn’t the job, it wasn’t the corruption, it wasn’t the politics—it was the impossible personal and private dilemma he found himself in. How much longer could he go on this way?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had become a stranger to his family, a stranger to the little girls who needed him—a stranger to his wife.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she wanted it that way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stood abruptly, terribly torn. A part of him was ruthlessly determined to go up those stairs, climb into her bed and simply hold her, even though he would find her stiff with tension, pretending to be asleep. When he reached for her, he knew she would turn away, refusing to allow him any opportunity for comfort or intimacy. And he could not blame her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leigh Anne had said she did not hold him responsible for the accident that had caused her to lose the use of her legs, but he blamed himself—and knew that, deep down, she blamed him, too.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Once, he had thought their marriage over. Years before the accident, soon after they were first married. She had left him to travel in Europe and he had hated her passionately. Now, too late, he had faced the extent of his passion. He still loved her and he always had. But it had become painfully obvious that she no longer cared in return. He knew what he should do. He should ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("give her the freedom she clearly wanted, but how could he? Who would take care of her if he did so? And what about the girls? If he left Leigh Anne, it would mean the loss of his family.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His heart seemed to crack apart at the thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stared at the dark, empty fireplace. The past flashed before his eyes—the moment he had first laid eyes on Leigh Anne, which was when he had fallen in love. Their wedding, and her happiness then. His sudden, unexpected decision to leave his profitable career to perform legal services for the poor and inopportune. Her unhappiness had followed, for he had turned his back on a sizable income and worked eighty-hour weeks instead. Finally, there was her betrayal. She had simply left him, walking out on their marriage. Too late, he wished he had never taken that damn employment, or that he had begged her to return.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he hadn’t. And four years of separation had limped by, until the night Francesca Cahill had come into his life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled, but his sadness increased. He wondered what would have happened if Leigh Anne had never returned to him. He still cared deeply for Francesca and he always would. Once, they had been on the verge of falling in love, but that seemed like a lifetime ago. Now he was committed to his wife and children—and Francesca was committed to his half brother. His smile vanished. Hart would break her heart. He knew it the way he knew that Leigh Anne wanted him to leave. He had not a single doubt, and the day Hart hurt her, he would break "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A sharp knocking sounded on the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg was relieved, as he hated thinking about Francesca with Hart. It was terribly late, so the call could only be police business—an emergency. Bragg grabbed his suit jacket from the back of his chair and hurried down the narrow hall of the modest Victorian brownstone he leased.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A roundsman stood there with a lantern, his expression alert. Bragg was already shrugging on his jacket. “What is it?” He did not know the young officer who faced him.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sir, there has been a murder. Inspector Newman thinks you might want to meet him at HQ, immediately.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was tense, and glad of the distraction. This could only be dire, indeed. “Who is the victim?” He stepped outside, closing the front door behind him. The early June night was cool, but not unpleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A woman. Her name is Miss Daisy Jones, sir.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An instant passed as he assimilated this stunning fact—Hart’s mistress had been murdered. “Newman is at headquarters? He is not at the murder scene?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, sir. There are some officers at the scene, but he has several witnesses to speak with, sir. He asked me to tell you that he is interviewing Calder Hart and Miss Cahill as we speak.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg tripped. For one moment, he was in disbelief. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hart was at HQ—with Francesca.")]), _vm._v(" And he simply knew that no good could come of this case.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RANCESCA SAT BESIDE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ART")]), _vm._v(" at the long, scarred wood table in the conference room of police headquarters. The room was on the second floor, just a door down from Bragg’s office. Inspector Newman, a rotund and pleasant man with graying hair with whom Francesca had worked many times, sat facing them, holding a notepad, and wearing his most professional demeanor. Francesca knew that was on her account, as he was very aware of her close relationship with Bragg.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("Francesca had already heard Hart’s story on the short ride from Daisy’s to Mulberry Street, when they had had a chance to speak. Now she watched him closely, carefully listening to his every word. She could not help herself, for she had learned on her numerous past investigations to check and recheck every detail. Witnesses often confused facts and events; perpetrators often deliberately misled the police. Of course, she was not suspicious of Hart and she expected him to keep his facts straight, and although his expression was deadpan, his tone calm, she ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("was certain now that he was very distressed by the evening’s events.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I left the train depot a few minutes before 7:00 p.m. As I was not expected, I took a cab home. Traffic was heavy and it was a good hour before I reached the house. An hour later I found a note from Daisy on my desk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which meant he had found her note at 9:00 p.m., approximately, Francesca thought.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And what did her note say?” Newman asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She wished to speak with me the moment I returned home and said it was very urgent.” Hart’s impassive expression never changed, but sitting beside him, Francesca could feel the tension coiled up in him. She could not help herself, and she reached out to cover his hand with her own. He glanced at her with a slight smile that failed to reach his gold-flecked eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And do you have any clue as to what could be so urgent?” Newman asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart did not hesitate. “I felt certain the matter was a financial one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Newman glanced at Francesca, his cheeks becoming a bit pink.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca was willing to let him off the hook. “I am well aware of the fact, Inspector, that Daisy was Calder’s mistress.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He blushed. “I am sorry, Miss Cahill, to bring up such a delicate subject. You spoke as if the affair had ended?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It ended the day Francesca agreed to become my wife,” Hart said flatly. “The morning of February 24.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca looked at him in real surprise. He recalled the exact date she had accepted his proposal? He turned to smile at her, when Rick Bragg walked purposefully into the room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("Francesca leapt to her feet, very relieved to see him. Calder’s half brother was a very handsome man, but the two men shared little resemblance. Bragg had tawny hair and a golden complexion, as did most of the Bragg men, while Hart was as dark ")]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("as midnight. He glanced between Francesca and Hart as he approached them, his expression grim. Hart’s face settled into an unreadable, emotionless mask.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca was aware of the new currents of tension swirling in the room as she clasped both of Rick’s hands. “I am so glad you are here! Calder was just giving his statement, Rick. Of course, you know that Daisy is dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So I have been told,” he said, kissing her cheek. “Are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded. “Yes, of course. But Rose is devastated.” She hesitated, then dared to add, “Calder is upset, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick clearly did not believe that. “What are you doing here, Francesca? You are a witness to the murder?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not really,” Francesca said quickly. She realized Bragg had not released her hands and that Hart watched them like a hawk. She gently disengaged herself. “Rose found the body and sent a note, asking me for help. It appears that Rose discovered Daisy first, and that Calder found her while Rose was sending me the note. When I got to the house, Rose was with Daisy and Calder was looking for the killer. He had just spoken with some of the staff.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg turned to Hart. “Don’t let me interrupt your statement.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart shrugged as if he had not a care in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg leaned over Newman’s shoulder and scanned his notes. As he did so, Newman said, “He received a note from Daisy requesting a meeting, sir. That would have been about nine o’clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg nodded, straightening. His aloof gaze met Hart’s. “So you rushed off to meet your mistress?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart sent him a cold, unpleasant smile. “You know damn well I broke off the affair when I became engaged to Francesca.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Newman looked startled. He said, “Sir, she was living in Mr. Hart’s house.”")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am aware of that. So, you rushed off to meet Daisy as she requested?” Bragg asked again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca walked over to stand beside Hart, dismayed that Bragg had instantly gone on an attack. Hart, who remained sitting rather indolently, did not give any sign of being shaken. “No, I did not rush off anywhere. It had been a long day and I had a drink, perhaps two. It was some time later when I decided to call on Daisy and conclude whatever affairs were bothering her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg made a mocking sound. “And those affairs were?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I assumed they were financial matters,” Hart said, slowly rising to his feet, “as the only connection left between me and Daisy was financial. I continued to support her—we had a verbal contract, and it did not expire until mid-July. But you know all of that, don’t you, Rick?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg stared and Hart stared back. Then Bragg glanced at Francesca. “I find it highly unlikely that you just returned to town and went to see Daisy to discuss a few bills.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t care what you think,” Hart said, finally appearing annoyed. “I never have and I never will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg looked ready to explode—or arrest him. Smiling tightly, he said, “Considering your mistress has been murdered, I think you had better start to care what I think.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart smiled as tightly, and for one moment, Francesca thought he was about to smash his fist in Bragg’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca hated the hostility between the two brothers. She gripped Hart’s arm. “A terrible murder has been committed,” she said tersely. “There is no point in the both of you going at each other’s throats. We need to find Daisy’s killer. We owe her that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg gave her an undecipherable look and walked away, running his hand through his hair. Hart faced her, his rigid expression softening. “You don’t need to be here right now,” he said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("Francesca gaped. “Of course I do!” she cried. She could not ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("tell him, not in front of Newman and Bragg, how worried she was about his apparent involvement. “When we go home, we will go home together,” she whispered.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before Hart could object, Bragg returned to them, apparently having recovered his composure. “Let’s leave the subject of why you went to see Daisy aside for the moment. Walk me through what happened when you arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some of Hart’s tension eased. “I left the house around half past eleven, I think. When I arrived at her home, I saw that there were no lights on downstairs. No one answered the knocker, and that was odd. I did not have a good feeling at this point. So I tried the door, found it unlocked and walked in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca could not breathe and her heart raced. The mental note she had made earlier was glaring at her now. Hart had said he had left home at eleven, not half past. Was he deliberately misleading Bragg and the police, or had he, like most witnesses, made an innocent factual error? And she wondered again, if he had really left home at 11:00 p.m., what had he been doing for nearly an entire hour in that house? Was that why he was misleading the police?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Almost as if he were a mind reader, he turned to Francesca. “What time did you get there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hesitated, her instincts rising up now. She did not want to lie, but she desperately wanted to protect Hart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Francesca?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wet her lips. “Before midnight,” she lied. “I imagine it was just a few minutes after Hart.” She could barely believe that she was lying to a man she had once loved and still cared so deeply for.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg rubbed his jaw. “Calder?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("“I found Daisy shortly after I first walked in,” he said, not looking at Francesca now. “It appeared as if she had been stabbed in the chest, many times. No one could survive such an attack, but I did check for her pulse.” He spoke very calmly, as if they ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("were discussing the next day’s weather, but he was gripping the back of the chair he had been sitting in and his knuckles were white.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca could not see his expression, because he had looked down, but she gave up all pretense now. Hart was distraught and anguished. He certainly still cared for Daisy, and Francesca was hurt and jealous, dear God.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Francesca wanted to comfort him, too, and she moved closer to him. Instantly he glanced at her. She sensed he wanted to reassure her, and any grief he might be feeling was masked. Then he looked at Bragg. “I sat with her for a moment,” he said calmly. “I was in shock. I was very much in shock.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg nodded. “There’s blood on your shirt,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart had tossed his charcoal-gray jacket aside. His shirtsleeves were rolled up, his dark tie loose and askew. He rarely wore a vest, and dried blood stained the finely woven white cotton material of his shirt. Now he glanced down at his own chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You held her?” Bragg asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca tensed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An interminable moment passed and Francesca thought Hart was recalling the moment he had first seen Daisy dead on the study floor. She touched his arm; he did not notice. “I saw her the moment I reached the study door. It was ajar. There was so much blood. I knew instantly that she had been murdered.” Hart finally looked at his half brother. “But I checked to see if she was breathing. She wasn’t. I was on my knees.” He stopped. He had spoken as if reciting notes for a university class. Now he looked down. “Yes, I held her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca turned away. Her heart beat so hard it hurt her there, inside of her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go on,” Bragg said to Hart, as if he had not just revealed his feelings, when they all knew he had.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("Hart shrugged. “I instantly wondered if the killer remained in the house. I was about to begin a search when I saw Rose ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("coming inside, without any kind of wrap. Clearly she had only just stepped out. I was suspicious and I made certain she did not see me. She went directly to the study. She was not surprised to find Daisy dead there, but she was very distraught.”")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She still did not see you?” Bragg asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart shook his head. “We all know that Rose was very fond of Daisy. Although her behavior seemed suspicious, I left to search the house, on the chance I might find either the killer or a clue. I had just finished speaking with the butler and a housemaid when I ran into Francesca.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And that would have been at midnight,” Bragg confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess so,” Hart said, suddenly sounding tired. “Are we through?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca would have been consumed with guilt for her deception, but there was too much worry and hurt. She could not get past the fact that Hart had admitted to holding Daisy in his arms, obviously grieving for her. She reminded herself that he had every right. After all, she still cared for Bragg. She would grieve until the day she died if anything ever happened to him. Why couldn’t she accept that Hart had continued to care for Daisy, too?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because she had always been jealous of the fact that Hart had once wanted Daisy enough to keep her as a mistress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca did not want to think about how insecure Daisy had always made her feel. She took a breath and plunged into the fray. “Rick, I arrived just a few moments before I bumped into Hart. When I arrived, the front door was ajar. I found Rose with Daisy, in grief. There was no sign of a murder weapon. I covered up the body and I also thought to look for the killer, as I heard a noise in the hall. That is when I ran into Calder on the stairs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you went to Daisy, for what reason?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("Francesca reached into her beaded velvet evening bag and ")]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("handed him the note. He read it and gave it to Newman. “Tag it,” he said. He faced Hart. “And the note Daisy sent you?”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart was rubbing his jaw. “It’s probably on my desk, where I left it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m afraid I will need it, Calder.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll send it to you,” Hart said. He walked away from Bragg and Francesca, as if deep in thought. Francesca watched him, aware of Bragg watching her. This was one case that she was not going to be enthusiastic about working on. She turned to Bragg. “Rose has admitted to finding Daisy murdered, Rick. I think we need to pursue her as a suspect, as distasteful as that is.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg spoke, not to Francesca but to Hart. “You have a houseful of witnesses, do you not, who will testify that you were at your home from the time you arrived there, at approximately 8:00 p.m., until you left for Daisy’s at half past eleven?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart faced them from a distance. “Alfred let me in when I returned from the depot. I am sure he saw me go out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg made a note. “And your driver can certainly testify to taking you to Daisy’s at half past eleven, can he not?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart’s expression was impassive. “I took a cab.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca almost groaned. “Rick! Hart was at home for at least three hours! I am sure quite a few staff can testify to that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg looked at her, not responding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca felt some panic bubble. Rick did not believe all that Hart had said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Rick, I want to speak to you alone,” Hart suddenly said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca was instantly alarmed. “Calder!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.” His eyes had become shards of steel. “I wish to speak with my brother privately.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("Francesca’s worry knew no bounds. She hesitated and Rick said, “I want to speak to him alone, as well. Francesca, it is late. I will finish with Hart and he can take you home, as long as you ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("promise me you will come in first thing in the morning to give an official statement.” He smiled at her.")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But she did not smile back. If they wished to speak alone, then they were going to discuss her—or discuss something they did not wish for her to hear. When both men united against her, it was a losing battle. She looked at Rick, who was smiling too benignly at her, then glanced at Hart, who was not smiling at all. He appeared ruthlessly determined, but to do what?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll take you home in a few minutes,” Hart said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew she could not prevent this private discussion. She sighed and faced Rick. “Of course I’ll come in tomorrow morning. What about Rose?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to interview her in a moment, if she is up to the task. If not, I will send her home with a police escort and speak with her in the morning, as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Francesca would be shocked if Rose were ever proven to be the killer. She felt very sorry for the woman. “Rick, she is in mourning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know.” He laid his hand on her back and guided her across the room to the door. “Newman? Why don’t you see Miss Cahill downstairs and begin speaking with Rose.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aye, sir,” Newman said.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ART WATCHED")]), _vm._v(" F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RANCESCA LEAVE.")]), _vm._v(" He was very deter mined, but a part of him almost called her back. Before the door closed she sent him a reassuring look. He knew her so well now, better than he had ever known anyone. Therefore, he had not a single doubt that Francesca genuinely wanted to comfort him, just as he knew she wanted to protect him. It was amazing, and he knew that later he’d be grateful. Tonight, however, he had no use for any emotions whatsoever, not even those engendered by his fiancée. Tonight, he refused to feel anything at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Images of Daisy filled his mind, her anger, her tears, and later, her bloody corpse.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart turned to Rick and said, “I do not want Francesca involved in this investigation, not in any way. She thinks to protect me but it is hardly necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg’s tawny brows lifted. “I could not agree more. How noble of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Inwardly he seethed. “We both know I am not noble, Rick, so don’t even begin. But even I am not rotten enough to put Franesca in the awkward position of defending me in the murder of my ex-mistress.” He did not want his past with Daisy—or any woman—thrown up in Francesca’s face, time and again. In fact, he had regretted his hedonistic past ever since meeting Francesca, or shortly there after. Although he could not change the past, he hoped to keep Francesca as far removed from it as he could. Yet to night, the past had somehow caught up with them both.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I could almost believe you are putting Francesca first,” Rick said, “except we both know you are not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart despised his brother’s self-righteous, judgmental nature. “Let’s finish, Rick.” His temper was explosive and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" felt good.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Rick was clearly not finished. “You don’t want Francesca to know why you went to see your mistress tonight, do you?” Rick was furious. “We both know you did not ride downtown to go over her expenses and accounts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart saw red. “Fuck you. I did not visit Daisy to sleep with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick stared. Finally said, “Then why? Because only some very urgent dispute or crisis would rouse you so late at night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tensed. Daisy’s sobs filled his mind, and the image was hateful. “I told you, it was a matter of finances. I’m not even sure what, exactly, the matter involved. She probably wanted more funds. I had asked her to leave the house last month, earlier than we had agreed. She refused and I had decided to let it go. Maybe she was going to ask me for a payoff.” He smiled coldly. “But we will never know now, will we?”")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How interesting this is, your word against the word of a dead woman. Why did you ask Daisy to leave the house earlier than the two of you had agreed she would go?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart had to hand it to his half brother—Rick never missed a trick. Calder had learned long ago to stick as closely to the truth as possible. “She had become difficult, even malicious, toward me—and worse, toward Francesca. I was angry with her and I had had enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bragg’s brows rose. “Were you angry with her to night?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” Hart said, and that was the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick saw it, too, because he nodded. “Is there anything else you wish to add?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick nodded again. “Come in tomorrow afternoon. Your statement will be ready and you can sign it.” He hesitated. “It wouldn’t hurt, Calder, to bring your lawyer with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart stiffened. “I don’t need a lawyer, because I did not murder anyone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick shrugged and started for the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart seized him from behind. “I meant what I said. I do not want Francesca working this case with you. Turn her away, Rick, when you see her tomorrow. She doesn’t need this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t dissuade her when she has set her mind to something.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can’t, or you won’t?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rick gave him an enigmatic look and he walked out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hart lost it. He kicked the door so hard that it hurt.")])])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page43"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755feff2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426884405_ch02.vue
// module id = 75
// module chunks = 0